<div class="catalog-structure">

  <table mat-table [dataSource]="datasource" class="mat-elevation-z8">
    @for (col of displayedColumns; track col; let colIndex = $index) {
      @if (col !== 'articleActions') {
        <ng-container matColumnDef="{{col}}">
          <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label [dictionaryKey]="col"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element"><span class="text">{{element[colIndex+1]}}</span></td>
        </ng-container>
      }
      @if (col === 'articleActions') {
        <ng-container matColumnDef="articleActions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="table-actions">
              <button mat-icon-button (click)="editArticle(element[0])">
                <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
              </button>
              <button mat-icon-button (click)="removeArticle(element[0])">
                <sc-action-icon iconClass="fa-trash"></sc-action-icon>
              </button>
            </div>
          </td>
        </ng-container>
      }
    }

    <!-- Group header -->
    <ng-container matColumnDef="groupHeader">
      <td [attr.colspan]="displayedColumns.length" mat-cell *matCellDef="let header">
        <sc-flex >
          <app-dictionary-entry-label [model]="header.name"></app-dictionary-entry-label>
          <sc-content-spacer grow></sc-content-spacer>
          <div>
            <button mat-icon-button (click)="addNode(header.catalogNode)">
              <sc-action-icon iconClass="fa-folder-plus"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="editNode(header.catalogNode)">
              <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="deleteNode(header.catalogNode)">
              <sc-action-icon iconClass="fa-trash"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="addArticle(header.catalogNode)">
              <sc-action-icon iconClass="fa-plus"></sc-action-icon>
            </button>
          </div>
        </sc-flex>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isHeader"> </tr>

  </table>
  <mat-paginator [pageSize]="50" [showFirstLastButtons]="true"></mat-paginator>
</div>
